export default __webpack_public_path__ + "static/media/video3.04aa61a1.webp";